import { render, staticRenderFns } from "./FileImportDialog.vue?vue&type=template&id=58a890a4&scoped=true"
import script from "./FileImportDialog.vue?vue&type=script&lang=js"
export * from "./FileImportDialog.vue?vue&type=script&lang=js"
import style0 from "./FileImportDialog.vue?vue&type=style&index=0&id=58a890a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a890a4",
  null
  
)

export default component.exports